
<div class="modal-body">
  <message class="danger">{{text}}</message>
  <label translate>To continue, enter following text in the field: "{{confirmation}}"</label>
  <input class="form-control" type="text" autofocus [(ngModel)]="input" (keydown.enter)="confirm()" data-test-qa="confirmationInput" id="confirmationInput" [srLabel]="&quot;Confirmation&quot;|translate">
</div>
<div class="modal-footer">
  <button class="btn btn-outline-danger" (click)="confirm()" [disabled]="!matches" data-test-qa="confirm" translate>{{buttonText}}</button>
  <button class="btn btn-outline-secondary" (click)="cancel()" data-test-qa="cancel" translate>Cancel</button>
</div>